import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';
import { MuiAvatar } from './avatar';
import { MuiButton } from './button';
import { MuiCard } from './card';
import { MuiCardContent } from './card-content';
import { MuiCardHeader } from './card-header';
import { MuiLink } from './link';
import { MuiStack } from './stack';
import { MuiTab } from './tab';
import { MuiButtonGroup } from './button-group';
import { MuiFormHelperText } from './form-helper-text';
import { MuiTableCell } from './table-cell';

export const components = {
  MuiAvatar,
  MuiButton,
  MuiButtonGroup,
  MuiCard,
  MuiCardContent,
  MuiCardHeader,
  MuiLink,
  MuiStack,
  MuiTab,
  MuiFormHelperText,
  MuiTableCell
} satisfies Components<Theme>;
